import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.group.name)
      ? (_openBlock(), _createBlock(_component_q_item, {
          key: 0,
          clickable: "",
          dense: "",
          class: "q-pt-sm",
          active: _ctx.selected,
          "active-class": "bg-primary text-white",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-category', _ctx.group.id)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, {
              avatar: "",
              style: {"min-width":"24px"},
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.open = !_ctx.open), ["stop"]))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: _ctx.open ? 'fa fa-chevron-down' : 'fa fa-chevron-right',
                  size: "xs",
                  color: _ctx.selected ? 'white' : 'grey'
                }, null, 8, ["name", "color"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { class: "text-weight-bold text-caption" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.group.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, { side: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_badge, {
                  color: _ctx.selected ? 'white' : 'grey-4',
                  "text-color": _ctx.selected ? 'primary' : 'grey-8'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.group.count), 1)
                  ]),
                  _: 1
                }, 8, ["color", "text-color"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["active"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_q_list, { dense: "" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.group.labels, (label) => {
          return (_openBlock(), _createBlock(_component_q_item, {
            key: label.id,
            clickable: "",
            active: _ctx.isSelected(label),
            "active-class": "bg-primary text-white",
            onClick: ($event: any) => (_ctx.$emit('toggle', label))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(label.name), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_q_item_section, { side: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_badge, {
                    color: _ctx.isSelected(label) ? 'white' : 'grey',
                    "text-color": _ctx.isSelected(label) ? 'primary' : 'white'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(label.count), 1)
                    ]),
                    _: 2
                  }, 1032, ["color", "text-color"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["active", "onClick"]))
        }), 128))
      ]),
      _: 1
    }, 512), [
      [_vShow, !_ctx.group.name || _ctx.open]
    ])
  ]))
}